/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-hide-event',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoHideEventComponent extends NestedOption {
    @Input()
    get delay(): number {
        return this._getOption('delay');
    }
    set delay(value: number) {
        this._setOption('delay', value);
    }

    @Input()
    get name(): string {
        return this._getOption('name');
    }
    set name(value: string) {
        this._setOption('name', value);
    }


    protected get _optionPath() {
        return 'hideEvent';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoHideEventComponent
  ],
  exports: [
    DxoHideEventComponent
  ],
})
export class DxoHideEventModule { }
